import { render, staticRenderFns } from "./Claimlinq.vue?vue&type=template&id=fabc4b4e&scoped=true"
import script from "./Claimlinq.vue?vue&type=script&lang=js"
export * from "./Claimlinq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabc4b4e",
  null
  
)

export default component.exports